module.exports = __webpack_public_path__ + "static/media/Wrap-up-04.ead0c81d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Wrap-up-04.mp3
// module id = 593
// module chunks = 0